module.exports = __webpack_public_path__ + "media/entities/2208-810c4014.png";